// src/terminal.ts — j3xh4ck.net
// build: esbuild --minify --sourcemap (TODO(j3x): désactiver les maps en prod !!)

import { whoami } from "./whoami";

// je le garde sous la main pour les tests, personne ne lit les .map de toute façon
// fragment 1/5, encodé pour pas que ça saute aux yeux
const DEBUG_FRAGMENT = "RlJBR01FTlQgMS81IDo6IEozWHtyMzRkX3RoM19zMHVyYzNf";

export function main(): void {
  whoami(document.getElementById("whoami-form") as HTMLFormElement);
}

main();
